import { Label } from '@facephi/ui-react';
import Skeleton from 'react-loading-skeleton';
import { CardKpiProps } from './model';
import {
  CardIcon,
  CardKpiContent,
  CardKpiIconContent,
  CardKpiWrapper,
} from './Styles';
import { CardDashboard } from '../CardDashboard';

export const CardKpi = ({
  iconName,
  title,
  count,
  subtitle,
  color,
  viewAllLink,
  viewAllText,
  testId,
  loading,
}: CardKpiProps) => {
  const getLoadingComponent = () => (
    <CardKpiWrapper flex="1">
      <CardKpiIconContent>
        <Skeleton height={70} width={70} borderRadius={8} />
      </CardKpiIconContent>
      <CardKpiContent testId={testId}>
        <Skeleton height={33} width="40%" borderRadius={14} />
        <Skeleton height={16} width="80%" borderRadius={14} />
        <Skeleton height={12} width="80%" borderRadius={14} />
      </CardKpiContent>
    </CardKpiWrapper>
  );

  const getComponent = () => (
    <CardKpiWrapper flex="1">
      <CardIcon
        gradient={color.gradient}
        iconName={iconName}
        size="XL"
        hasIconWhite
      />
      <CardKpiContent testId={testId}>
        <Label fontSize="32" as="h3" semibold color={color.label}>
          {count}
        </Label>
        <Label fontSize="16" as="h2" semibold>
          {title}
        </Label>
        <Label fontSize="12">{subtitle}</Label>
      </CardKpiContent>
    </CardKpiWrapper>
  );

  return (
    <CardDashboard
      viewAllLink={viewAllLink}
      viewAllText={viewAllText}
      loading={loading}
    >
      {loading ? getLoadingComponent() : getComponent()}
    </CardDashboard>
  );
};
